"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SskySelect = void 0;

const material_1 = require("@mui/material");

const classnames_1 = __importDefault(require("classnames"));

const react_1 = __importDefault(require("react"));

const StyledMenuItem = (0, material_1.styled)(material_1.MenuItem)({
  height: 48
});
const StyledFormControl = (0, material_1.styled)(material_1.FormControl, {
  shouldForwardProp: prop => prop !== "minWidth" && prop !== "width"
})(({
  minWidth,
  width
}) => ({
  minWidth: minWidth || 120,
  width
}));
const StyledLabel = (0, material_1.styled)(material_1.InputLabel)({
  fontSize: 16
});
const StyledSelect = (0, material_1.styled)(material_1.Select, {
  shouldForwardProp: prop => prop !== "selectValueStyle"
})(({
  selectValueStyle
}) => Object.assign({}, selectValueStyle));

const SskySelect = props => {
  const renderItems = () => {
    const menuItems = props.items.map((item, index) => {
      if (typeof item === "object") {
        return react_1.default.createElement(StyledMenuItem, {
          key: item.key,
          value: item.value,
          disabled: item.disabled,
          divider: item.divider,
          "data-testid": item.dataTestId || `testId-menu-item-${item.key || index}`
        }, item.text);
      }

      return react_1.default.createElement(StyledMenuItem, {
        key: item,
        value: item
      }, item);
    });

    if (props.noneOptionDisplayText) {
      menuItems.unshift(react_1.default.createElement(StyledMenuItem, {
        key: 0,
        value: ""
      }, react_1.default.createElement("em", null, props.noneOptionDisplayText)));
    }

    return menuItems;
  };

  return react_1.default.createElement(StyledFormControl, {
    id: props.id,
    className: (0, classnames_1.default)("SskySelect", props.className),
    error: props.error,
    disabled: props.disabled,
    minWidth: props.minWidth,
    width: props.width
  }, react_1.default.createElement(StyledLabel, {
    shrink: props.noneOptionDisplayText && props.displayEmpty !== false ? true : undefined
  }, props.label), react_1.default.createElement(StyledSelect, {
    value: props.value,
    onChange: props.onChange,
    onClose: props.onClose,
    onOpen: props.onOpen,
    renderValue: props.renderValue,
    disableUnderline: props.disableUnderline,
    open: props.open,
    displayEmpty: props.displayEmpty !== undefined ? props.displayEmpty : !!props.noneOptionDisplayText,
    "data-testid": props.dataTestId || `testId-${props.id || props.label}`,
    variant: props.variant || "standard",
    selectValueStyle: props.selectValueStyle
  }, renderItems()), react_1.default.createElement(material_1.FormHelperText, null, props.helperText));
};

exports.SskySelect = SskySelect;
SskySelect.defaultProps = {
  value: ""
};
exports.default = react_1.default.memo(SskySelect);